import { render, staticRenderFns } from "./BookingKanbanCard.vue?vue&type=template&id=275a4a51&scoped=true&"
import script from "./BookingKanbanCard.vue?vue&type=script&lang=js&"
export * from "./BookingKanbanCard.vue?vue&type=script&lang=js&"
import style0 from "./BookingKanbanCard.vue?vue&type=style&index=0&id=275a4a51&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275a4a51",
  null
  
)

export default component.exports